<ion-row class="grievance-box ion-text-center">
  <ion-col size="12" size-sm="auto" class="grievance-img-box">
    <!-- <img class="grievance-img" src="././assets/icon/activeEmp.svg"> -->
    <span class="material-symbols-outlined grievance-img">person_raised_hand</span>
  </ion-col>
  <ion-col size="12" size-sm class="grievance-content-box">
    <p class="grievance-content-header font_semibold fs-14 fs_12ForMobile"> {{ countData.value }} Count</p>
    <p class="grievance-content-count font_bold mt-10">{{ countData.count }}</p>
  </ion-col>
</ion-row>